import axios from "../../../axios";

export const totalCount = async () => {
    try{        
        let { data } = await axios.get(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/dashboard/widget`);               
        return data;
    } catch (e) {
        console.log("errors", e)
    }
}
